var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{staticStyle:{"margin":"0","padding":"0"},attrs:{"input-value":_vm.isActive,"dense":"","hide-details":""},on:{"change":function($event){return _vm.toggleActive($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }